module.exports = __webpack_public_path__ + "static/media/slide.78249887.mp3";